module.exports = __webpack_public_path__ + "img/logo.478b0919.png";